import { render, staticRenderFns } from "./LoaderPage.vue?vue&type=template&id=11a792a4&"
import script from "./LoaderPage.vue?vue&type=script&lang=js&"
export * from "./LoaderPage.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports